import { Action } from "@ngrx/store";
import { WidgetConfiguration } from "../models/widget-configuration"

export const LOAD = '[Widget Configurations] Load';
export const LOAD_BY_PROFILE = '[Widget Configurations] Load By Profile';
export const LOAD_ALL = '[Widget Configurations] LoadAll';
export const LOAD_COMPLETE = '[Widget Configurations] Load Complete';
export const LOAD_ERROR = '[Widget Configurations] LoadAll Error';

export const UPDATE = '[Widget Configurations] Update';
export const UPDATE_COMPLETE = '[Widget Configurations] Update Complete';
export const UPDATE_ERROR = '[Widget Configurations] Update Error';


export class Load implements Action {
  readonly type = LOAD;
  constructor(public dashboardIdentifier: string) { }
}

export class LoadByProfile implements Action {
  readonly type = LOAD_BY_PROFILE;
  constructor(public dashboardIdentifier: string, public profileId: number) { }
}

export class LoadAll implements Action {
  readonly type = LOAD_ALL;
  constructor(public product: string) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: Array<WidgetConfiguration>) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any) { }
}

export type Actions =
  Load |
  LoadByProfile |
  LoadAll |
  LoadComplete |
  LoadError
